export const isObjectKind = (value: unknown): value is Record<string, unknown> => {
  if (value === null) {
    return false;
  }

  return typeof value === 'object';
};

export const isObjectKindOrUndefined = (
  value: unknown,
): value is Record<string, unknown> | undefined => {
  return value === undefined || isObjectKind(value);
};
